export const ko = {
  common: {
    loading: '로딩 중...',
    error: '오류가 발생했습니다',
    retry: '재시도',
    save: '저장',
    cancel: '취소',
    delete: '삭제',
    confirm: '확인',
    back: '뒤로',
    close: '닫기',
    search: '검색',
    noData: '데이터 없음',
  },
  tabs: {
    home: '홈',
    settings: '설정',
    profile: '프로필',
  },
  settings: {
    title: '설정',
    theme: '테마',
    themeLight: '라이트',
    themeDark: '다크',
    themeSystem: '시스템',
    language: '언어',
    version: '버전',
    about: '소개',
  },
  home: {
    title: '홈',
    welcome: '환영합니다',
    description: '기능을 편집하여 시작하세요.',
  },
  admin: {
    nav: {
      dashboard: '대시보드',
      users: '사용자',
      posts: '게시판',
      settings: '설정',
      activity: '활동 로그',
      notifications: '알림',
      menu: '메뉴',
      collapse: '접기',
    },
    header: { title: '관리자 패널' },
    dashboard: {
      title: '대시보드',
      subtitle: '워크스페이스 개요입니다.',
      greeting: '{{name}}님, 안녕하세요',
      todayOverview: '오늘의 워크스페이스 현황입니다.',
      stats: {
        totalUsers: '전체 사용자',
        activeProjects: '활성 프로젝트',
        tasksCompleted: '완료된 작업',
        pendingReviews: '검토 대기',
      },
      recentActivity: '최근 활동',
      viewAll: '전체 보기',
      vsLastMonth: '전월 대비',
      noActivity: '표시할 최근 활동이 없습니다.',
      systemHealth: '시스템 상태',
      uptime: '가동률',
      responseTime: '평균 응답',
      errorRate: '오류율',
      allOperational: '모든 시스템 정상 운영 중',
    },
    users: {
      title: '사용자',
      subtitle: '사용자 계정과 권한을 관리합니다.',
      addUser: '사용자 추가',
      search: '사용자 검색...',
      totalMembers: '전체 멤버',
      activeNow: '활성',
      admins: '관리자',
      activeRate: '활성률 {{rate}}%',
      noResults: '사용자를 찾을 수 없습니다',
      noResultsHint: '검색어를 변경해 보세요',
      filterAll: '전체',
      table: {
        name: '이름',
        email: '이메일',
        role: '역할',
        status: '상태',
        department: '부서',
        lastLogin: '마지막 로그인',
      },
      form: {
        createTitle: '사용자 추가',
        editTitle: '사용자 수정',
        nameLabel: '이름',
        namePlaceholder: '이름을 입력하세요',
        emailLabel: '이메일',
        emailPlaceholder: 'email@example.com',
        roleLabel: '역할',
        rolePlaceholder: '역할을 선택하세요',
        statusLabel: '활성',
        statusHint: '비활성 사용자는 로그인할 수 없습니다.',
        save: '저장',
        saving: '저장 중...',
        cancel: '취소',
        avatar: '아바타',
        phone: '전화번호',
        department: '부서',
        bio: '소개',
        joinDate: '가입일',
        lastLogin: '마지막 로그인',
        phonePlaceholder: '전화번호',
        departmentPlaceholder: '부서명',
        bioPlaceholder: '간단한 소개...',
      },
      actions: {
        edit: '수정',
        delete: '삭제',
        activate: '활성화',
        deactivate: '비활성화',
        sendMessage: '메시지 보내기',
        sendPush: '푸쉬 전송',
      },
      bulk: {
        selected: '{{count}}명 선택',
        message: '메시지',
        push: '푸쉬',
        delete: '삭제',
      },
      messageDialog: {
        title: '메시지 보내기',
        placeholder: '메시지를 입력하세요...',
        send: '전송',
      },
      pushDialog: {
        title: '푸쉬 알림 전송',
        recipient: '대상: {{name}}',
        recipientBulk: '대상: {{count}}명',
        titleLabel: '제목',
        titlePlaceholder: '알림 제목',
        bodyLabel: '내용',
        bodyPlaceholder: '알림 내용...',
        send: '푸쉬 전송',
      },
      bulkDeleteConfirm: {
        title: '{{count}}명 사용자 삭제',
        description:
          '선택된 모든 사용자를 영구 삭제하고 접근 권한을 회수합니다.',
      },
      deleteConfirm: {
        title: '사용자 삭제',
        description: '사용자를 영구 삭제하고 모든 접근 권한을 회수합니다.',
        confirm: '삭제',
        cancel: '취소',
      },
      pagination: {
        showing: '{{total}}명 중 {{from}}-{{to}}',
      },
      toast: {
        deleted: '사용자가 삭제되었습니다',
        activated: '사용자가 활성화되었습니다',
        deactivated: '사용자가 비활성화되었습니다',
        messageSent: '{{name}}에게 메시지를 전송했습니다',
        pushSent: '{{name}}에게 푸쉬 알림을 전송했습니다',
        bulkDeleted: '{{count}}명의 사용자가 삭제되었습니다',
        bulkMessageSent: '{{count}}명에게 메시지를 전송했습니다',
        bulkPushSent: '{{count}}명에게 푸쉬를 전송했습니다',
      },
      roles: {
        admin: '관리자',
        member: '멤버',
        viewer: '뷰어',
      },
    },
    posts: {
      title: '게시판',
      subtitle: '게시글을 작성하고 관리합니다.',
      addPost: '새 글 작성',
      search: '게시글 검색...',
      totalPosts: '전체',
      published: '게시됨',
      draft: '임시저장',
      all: '전체',
      allCategories: '전체 카테고리',
      noResults: '게시글을 찾을 수 없습니다',
      noResultsHint: '검색어 또는 필터를 변경해 보세요',
      table: {
        title: '제목',
        author: '작성자',
        category: '카테고리',
        status: '상태',
        date: '작성일',
      },
      form: {
        createTitle: '새 글 작성',
        editTitle: '글 수정',
        titleLabel: '제목',
        titlePlaceholder: '게시글 제목을 입력하세요',
        contentLabel: '내용',
        contentPlaceholder: '게시글 내용을 작성하세요...',
        categoryLabel: '카테고리',
        categoryPlaceholder: '카테고리를 선택하세요',
        statusLabel: '바로 게시',
        statusHint: '임시저장 글은 관리자에게만 보입니다.',
        save: '저장',
        saving: '저장 중...',
        cancel: '취소',
        saved: '게시글이 저장되었습니다',
        deleted: '게시글이 삭제되었습니다',
        coverImage: '커버 이미지',
        coverImageHint: '드래그 앤 드롭 또는 클릭하여 업로드',
        removeCoverImage: '삭제',
        tags: '태그',
        tagsPlaceholder: '태그를 입력하고 Enter를 누르세요',
        excerpt: '요약',
        excerptPlaceholder: '미리보기용 간단한 요약...',
      },
      actions: {
        edit: '수정',
        delete: '삭제',
        publish: '게시',
        unpublish: '게시 취소',
        sendPush: '푸쉬 전송',
        copyLink: '링크 복사',
      },
      bulk: {
        selected: '{{count}}개 선택',
        publish: '게시',
        unpublish: '게시 취소',
        push: '푸쉬',
        delete: '삭제',
      },
      pushDialog: {
        title: '푸쉬 알림 전송',
        recipient: '게시글: {{name}}',
        recipientBulk: '대상: {{count}}개 게시글',
        titleLabel: '제목',
        titlePlaceholder: '알림 제목',
        bodyLabel: '내용',
        bodyPlaceholder: '알림 내용...',
        send: '푸쉬 전송',
      },
      bulkDeleteConfirm: {
        title: '{{count}}개 게시글 삭제',
        description:
          '선택된 모든 게시글을 영구 삭제합니다. 되돌릴 수 없습니다.',
      },
      toast: {
        deleted: '게시글이 삭제되었습니다',
        published: '게시글이 게시되었습니다',
        unpublished: '게시글이 비공개 처리되었습니다',
        pushSent: '"{{title}}" 푸쉬 전송 완료',
        linkCopied: '링크가 복사되었습니다',
        bulkDeleted: '{{count}}개의 게시글이 삭제되었습니다',
        bulkPublished: '{{count}}개의 게시글이 게시되었습니다',
        bulkUnpublished: '{{count}}개의 게시글이 비공개 처리되었습니다',
        bulkPushSent: '{{count}}개 게시글 푸쉬 전송 완료',
      },
      deleteConfirm: {
        title: '게시글 삭제',
        description: '이 작업은 되돌릴 수 없습니다. 게시글이 영구 삭제됩니다.',
        confirm: '삭제',
        cancel: '취소',
      },
      pagination: {
        showing: '{{total}}건 중 {{from}}-{{to}}',
      },
      categories: {
        announcement: '공지사항',
        guide: '가이드',
        internal: '내부',
        report: '리포트',
      },
    },
    settings: {
      title: '설정',
      subtitle: '계정 및 앱 환경설정을 관리합니다.',
      profile: {
        title: '프로필',
        nameLabel: '이름',
        emailLabel: '이메일',
        roleLabel: '역할',
        save: '변경사항 저장',
      },
      app: {
        title: '앱 설정',
        siteNameLabel: '사이트 이름',
        languageLabel: '기본 언어',
        timezoneLabel: '타임존',
      },
      notifications: {
        title: '알림 설정',
        emailLabel: '이메일 알림',
        emailHint: '이메일로 업데이트를 받습니다.',
        pushLabel: '푸쉬 알림',
        pushHint: '앱 내 푸쉬 알림을 받습니다.',
      },
      toast: {
        saved: '설정이 저장되었습니다',
      },
    },
    activity: {
      title: '활동 로그',
      subtitle: '관리자 활동과 변경 이력을 추적합니다.',
      search: '활동 검색...',
      filterAll: '전체',
      filterUser: '사용자',
      filterPost: '게시글',
      filterSystem: '시스템',
      noResults: '활동 내역이 없습니다',
      noResultsHint: '검색어 또는 필터를 변경해 보세요.',
      table: {
        user: '사용자',
        action: '액션',
        target: '대상',
        date: '일시',
        ip: 'IP',
      },
      actions: {
        created_user: '사용자 생성',
        deleted_user: '사용자 삭제',
        updated_user: '사용자 수정',
        created_post: '게시글 작성',
        deleted_post: '게시글 삭제',
        published_post: '게시글 게시',
        updated_settings: '설정 변경',
        sent_push: '푸쉬 알림 전송',
        login: '로그인',
        export: '데이터 내보내기',
      },
    },
    notifications: {
      title: '알림 관리',
      subtitle: '푸쉬 알림 발송 이력과 템플릿을 관리합니다.',
      tabs: {
        history: '발송 이력',
        templates: '템플릿',
      },
      search: '알림 검색...',
      newNotification: '새 알림',
      newTemplate: '새 템플릿',
      noResults: '알림 내역이 없습니다',
      noResultsHint: '첫 번째 푸쉬 알림을 전송해보세요.',
      noTemplates: '템플릿이 없습니다',
      noTemplatesHint: '재사용 가능한 알림 템플릿을 만들어보세요.',
      stats: {
        totalSent: '전체 발송',
        thisWeek: '이번 주',
        openRate: '열람률',
      },
      table: {
        title: '제목',
        body: '내용',
        recipients: '수신자',
        status: '상태',
        date: '발송일',
      },
      status: {
        sent: '발송 완료',
        scheduled: '예약',
        failed: '실패',
      },
      sendDialog: {
        title: '알림 전송',
        titleLabel: '제목',
        titlePlaceholder: '알림 제목',
        bodyLabel: '내용',
        bodyPlaceholder: '알림 내용...',
        targetLabel: '대상',
        targetAll: '전체 사용자',
        targetAdmins: '관리자만',
        targetMembers: '멤버만',
        send: '전송',
      },
      templateDialog: {
        title: '템플릿 저장',
        nameLabel: '템플릿 이름',
        namePlaceholder: '예: 주간 업데이트',
        titleLabel: '알림 제목',
        titlePlaceholder: '제목 템플릿',
        bodyLabel: '알림 내용',
        bodyPlaceholder: '내용 템플릿...',
        save: '템플릿 저장',
      },
      toast: {
        sent: '{{count}}명에게 알림을 전송했습니다',
        templateSaved: '템플릿이 저장되었습니다',
        templateDeleted: '템플릿이 삭제되었습니다',
      },
      actions: {
        useTemplate: '사용',
        deleteTemplate: '삭제',
      },
    },
  },
  landing: {
    nav: {
      goldPrice: '금시세',
      about: '사업소개',
      reservation: '방문예약',
      report: '태범리포트',
    },
    hero: {
      badge: '현물 자산 전문 기업',
      title: '실물 자산 거래의 기준을',
      titleHighlight: '다시 세웁니다.',
      subtitle:
        '태범귀금속은 정련 기반의 감정 기술과 실시간 시세 데이터를 바탕으로 귀금속과 산업 원자재의 가치를 더 투명하게 연결합니다.',
      keyMessage: '직접 매입하고, 직접 공급합니다.',
      ctaPrimary: '실시간 시세 확인',
      ctaSecondary: '내 자산 평가받기',
    },
    about: {
      title: '전통의 신뢰 위에,',
      titleHighlight: '디지털의 혁신을 더하다.',
      description:
        '태범귀금속은 귀금속 시장의 투명한 거래 질서를 확립하고 고객 자산의 가치를 가장 합리적인 기준으로 평가하는 현물 자산 전문 기업입니다.',
      descriptionSub:
        '오랜 시간 축적된 감정 노하우와 시장 분석력을 기반으로 단순한 거래를 넘어, 정확한 기준과 신뢰를 제공하는 구조를 만들어갑니다.',
      points: {
        valuation: {
          title: '정직한 가치 산정',
          description:
            '엄격한 검인 체계를 통해 순도와 중량을 정확하게 평가합니다.',
        },
        realtime: {
          title: '실시간 시세 반영',
          description:
            '국내외 시세를 기반으로 시장가에 근접한 거래 기준을 제공합니다.',
        },
        customized: {
          title: '고객 맞춤 자산 관리',
          description: '개인과 기업 모두에게 최적화된 거래 환경을 제공합니다.',
        },
      },
      buyRequest: '매입 신청',
    },
    differentiators: {
      title: '유통을 줄이고,',
      titleHighlight: '기준을 높였습니다.',
      subtitle: '우리는 이렇게 다릅니다',
      items: {
        directPurchase: {
          title: '직접 매입 구조',
          description: '중간 유통 없이 더 높은 매입가를 제공합니다.',
        },
        refiningEvaluation: {
          title: '정련 기반 평가',
          description:
            '금, 은, 팔라듐, 구리 등 자산 가치를 더 정밀하게 판단합니다.',
        },
        directSupply: {
          title: '직접 공급 시스템',
          description: '기업 고객에게 안정적인 원자재 공급을 연결합니다.',
        },
      },
    },
    businessAreas: {
      title: '귀금속을 넘어,',
      titleHighlight: '산업 원자재까지.',
      description:
        '태범귀금속은 단순한 금 거래를 넘어 현물 자산 전반을 다루는 구조로 확장되고 있습니다.',
      items: {
        purchase: '순금 / 18K / 14K / 백금 / 은 / 구리 매입',
        supply: '골드바 / 실버바 공급',
        b2b: '기업 대상 원자재 B2B 공급',
        store: '직영점 운영',
        online: '플랫폼 온라인 사업 운영',
        production: '골드바 / 주얼제품 제작',
      },
    },
    platform: {
      subtitle: '가치를 더 투명하게, 거래를 더 견고하게',
      description:
        '폐쇄적이고 복잡했던 귀금속 거래 시장을 넘어, 누구나 더 명확한 정보와 더 신뢰할 수 있는 구조 안에서 거래할 수 있도록 태범이 새로운 디지털 플랫폼을 준비하고 있습니다.',
      bannerTitle: '기준을 위한 플랫폼, 곧 선보입니다',
      benefitsTitle: '플랫폼이 시장을 바꿉니다',
      benefits: {
        distribution: {
          title: '유통 구조 단축',
          description:
            '기존 다단계 유통을 제거하고 직접 거래 구조를 통해 판매자는 더 높은 가격, 구매자는 더 낮은 가격을 경험합니다.',
        },
        data: {
          title: '데이터 기반 시세',
          description:
            '실시간 시세와 거래 데이터를 공개하여 누구나 정확한 시장 기준으로 거래할 수 있습니다.',
        },
        trust: {
          title: '검증된 안전 거래',
          description:
            '태범귀금속의 감정 역량을 기반으로 모든 거래의 품질과 신뢰를 보증합니다.',
        },
      },
    },
    cta: {
      title: '지금, 당신의 자산 가치를 확인해보세요.',
      ctaPrimary: '실시간 시세 보기',
      ctaSecondary: '매입 상담 신청',
      step1: '온라인 매입 접수',
      step2: '매장 방문 & 정밀 감정',
      step3: '자산 확장',
    },
    goldPrice: {
      title: '실시간 금시세',
      prevDay: '전일 대비',
      changeRate: '변동률',
      international: '국제 시세',
      domestic: '국내 도매 시세',
      taebum: '태범 시세(살 때)',
      sell: '매입 시세(내가 팔때)',
    },
    report: {
      subtitle: '한눈에 보는 이슈',
      title: '태범리포트',
      viewAll: '전체 글 보기',
      readMore: '읽기',
      backToList: '목록으로',
      otherReports: '다른 리포트 보기',
      allCategory: '전체',
    },
    purchase: {
      title: '매입 상담 신청',
      description:
        '아래 정보를 입력해주시면, 담당자가 빠르게 연락드리겠습니다.',
      name: '이름',
      namePlaceholder: '홍길동',
      phone: '연락처',
      phonePlaceholder: '010-0000-0000',
      item: '품목',
      itemPlaceholder: '품목을 선택해주세요',
      items: {
        pureGold: '순금 (24K)',
        gold18k: '18K 금',
        gold14k: '14K 금',
        silver: '은',
        platinum: '백금',
        other: '기타',
      },
      weight: '중량 (g)',
      weightPlaceholder: '예: 37.5',
      memo: '메모',
      memoPlaceholder: '추가 요청 사항이 있으면 입력해주세요',
      submit: '신청하기',
      preparing:
        '현재 온라인 접수 기능을 준비 중입니다.\n매장으로 직접 연락주세요.',
      purchaseOnlyLabel: '매입',
    },
    footer: {
      companyName: '태범귀금속',
      copyright: 'All rights reserved.',
      privacy: '개인정보처리방침',
      terms: '이용약관',
    },
  },
};
